import { HaulWareConnection_Read } from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

export class HaulWareConnection {
  constructor(
    private _id: string,
    private _company_id: string,
    private _enabled: boolean,
    private _export_mode: HaulWareConnection_Read['export_mode'],
    private _export_after: Dayjs | null,
    private _app_code: string,
    private _api_user: string,
    private _created_at: Dayjs,
    private _updated_at: Dayjs,
  ) {}

  public get id() {
    return this._id;
  }

  public get companyId() {
    return this._company_id;
  }

  public get enabled() {
    return this._enabled;
  }

  public get exportMode() {
    return this._export_mode;
  }

  public get exportAfter() {
    return this._export_after;
  }

  public get appCode() {
    return this._app_code;
  }

  public get apiUser() {
    return this._api_user;
  }

  public get createdAt() {
    return this._created_at;
  }

  public get updatedAt() {
    return this._updated_at;
  }

  public static parse(proto: HaulWareConnection_Read) {
    return new HaulWareConnection(
      proto.id,
      proto.company_id,
      proto.enabled,
      proto.export_mode,
      proto.export_after ? dayjs(proto.export_after) : null,
      proto.app_code,
      proto.api_user,
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
    );
  }
}
